const TalkType = {
  Workshop: "Workshop",
  Mini: "Mini",
}

const generateIds = (day) => {
  const result = []
  for (const [i, item] of day.entries()) {
    result[i] = {
      ...item,
      id: `${item.title}${i}${item.time}`,
      type: item.type || TalkType.Workshop,
      desc: item.desc || "",
    }
  }
  return result
}

const day1 = generateIds([
  {
    title: "开幕演讲&QA",
    host: [
      ["黄一孟", "心动创始人"],
      ["戴云杰", "TapTap CEO"],
      ["江宏", "TapTap 开发者服务负责人"],
    ],
    host_role: "TapTap",
    time: "10:00-12:00",
    video:
      "//player.bilibili.com/player.html?aid=489495076&bvid=BV1gN41187GT&cid=1224486564&page=1",
  },
  {
    title: "线下沙龙直播",
    host: [
      ["黄一孟", "心动创始人"],
      ["戴云杰", "TapTap CEO"],
      ["江宏", "TapTap 开发者服务负责人"],
    ],
    host_role: "TapTap",
    time: "13:30-16:30",
    video:
      "//player.bilibili.com/player.html?aid=914464208&bvid=BV1Yu4y1B793&cid=1224868162&page=1",
  },
])
const day2 = generateIds([
  {
    title: "《霓虹深渊：无限》是如何进行手游化改编的",
    host: "刘挺",
    host_role: "乙亥互娱CEO",
    time: "12:00-12:30",
    video:
      "//player.bilibili.com/player.html?aid=489389472&bvid=BV1MN411a75T&cid=1224350475&page=1",
  },
  {
    title: "《黎明前20分钟》如何用14个月实现从0到100万+",
    host: "Estelle",
    host_role: "Erabit工作室负责人",
    time: "12:30-12:45",
    styleTextSm: true,
    video:
      "//player.bilibili.com/player.html?aid=871970631&bvid=BV1DV4y1e7QG&cid=1224322763&page=1",
  },
  {
    title: "助力开发者商业成功",
    host: "冯峰",
    host_role: "TapTap 商业化工程负责人",
    time: "12:45-13:15",
    video:
      "//player.bilibili.com/player.html?aid=871890482&bvid=BV1dV4y1i7oX&cid=1224326604&page=1",
  },
  {
    title: "原点计划玩法设计及研发经历",
    host: "陆星儿",
    host_role: "《原点计划》制作人",
    time: "13:15-13:25",
    video:
      "//player.bilibili.com/player.html?aid=359382687&bvid=BV1fX4y177Sr&cid=1224342751&page=1",
  },
  {
    title: "Optillusion 核心观念：创造 Wow Moment",
    host: "周栋",
    host_role: "《笼中窥梦》制作人",
    time: "13:25-13:35",
    video:
      "//player.bilibili.com/player.html?aid=531897680&bvid=BV1Qu411J7PJ&cid=1224369534&page=1",
  },
  {
    title: "玩转TapTap各阶段流量",
    host: "戴天啸",
    host_role: "TapTap 发行支持负责人",
    time: "13:35-14:05",
    video:
      "//player.bilibili.com/player.html?aid=531957127&bvid=BV1gu411n7dM&cid=1224370405&page=1",
  },
  {
    title: "3人团队游戏-神仙打架半年拿下第一桶金",
    host: "阿阔",
    host_role: "《神仙打架》制作人",
    time: "14:05-14:15",
    video:
      "//player.bilibili.com/player.html?aid=316908879&bvid=BV1eP411t7Bp&cid=1224375980&page=1",
  },
  {
    title: "为单机游戏设计世界观与故事",
    host: "张弢",
    host_role: "钛核TiGames CEO《暗影火炬城》制作人",
    time: "14:15-14:30",
    video:
      "//player.bilibili.com/player.html?aid=616977218&bvid=BV1zh4y1F7Px&cid=1224376273&page=1",
  },
  {
    title: "游戏发布、运营的能力变化与新玩法简述",
    host: "苑志鹏",
    host_role: "TapTap 开发者运营负责人",
    time: "14:30-15:00",
    video:
      "//player.bilibili.com/player.html?aid=404380185&bvid=BV1SV411G75z&cid=1224382546&page=1",
  },
  {
    title: "星火编辑器让制作游戏更简单",
    host: "姜黎",
    host_role: "《星火编辑器》负责人",
    time: "15:00-15:10",
    video:
      "//player.bilibili.com/player.html?aid=489466443&bvid=BV1cN41187BQ&cid=1224382545&page=1",
  },
  {
    title: "《卡牌迷境》开发过程分享",
    host: "老李",
    host_role: "《卡牌迷境》制作人",
    time: "15:10-15:30",
    video:
      "//player.bilibili.com/player.html?aid=404453346&bvid=BV1GV411V78a&cid=1224382544&page=1",
  },
  {
    title: "零成本出海",
    host: "黄倩文",
    host_role: "TapTap 海外商务经理",
    time: "15:30-16:00",
    video:
      "//player.bilibili.com/player.html?aid=744451720&bvid=BV1vk4y1g7Vx&cid=1224412613&page=1",
  },
  {
    title: "完美的三次坑",
    host: "邓卜冉",
    host_role: "《完美的一天》制作人",
    time: "16:00-16:15",
    video:
      "//player.bilibili.com/player.html?aid=829492107&bvid=BV18u4y1R7hZ&cid=1224412478&page=1",
  },
  {
    title: "通过《R.O.O.T.》聊聊和玩家“对话”",
    host: "红魔",
    host_role: "《R.O.O.T.》制作人",
    time: "16:15-16:30",
    video:
      "//player.bilibili.com/player.html?aid=531947502&bvid=BV1ou411J7Pu&cid=1224449630&page=1",
  },
  {
    title: "TapTap独家合作",
    host: "张瑾",
    host_role: "TapTap 商务总监",
    time: "16:30-17:00",
    video:
      "//player.bilibili.com/player.html?aid=316956110&bvid=BV1dP411s7m7&cid=1224450203&page=1",
  },
  {
    title: "让策划自己实现 GamePlay 需求的开发",
    host: "JuJu",
    host_role: "《白荆回廊》制作人",
    time: "17:00-17:20",
    // video:
    //   "//player.bilibili.com/player.html?aid=489441333&bvid=BV1CN411b7tZ&cid=1227050168&page=1",
  },
  {
    title: "资源联动-游戏增长新机会",
    host: "宋策",
    host_role: "TapTap IEM产品运营负责人",
    time: "17:20-17:50",
    video:
      "//player.bilibili.com/player.html?aid=701915805&bvid=BV19m4y1W7f9&cid=1224450128&page=1",
  },
])

const day1DateStr = "08-05"
const day2DateStr = "08-06"

// const day1DateStr = "07-26"
// const day2DateStr = "07-27"

const daysData = [
  {
    time: [
      new Date(`2023-${day1DateStr}T09:30:00.000+08:00`),
      new Date(`2023-${day1DateStr}T18:30:00.000+08:00`),
      // new Date(`2022-${day1DateStr}T12:30:00.000+08:00`),
      // new Date(`2022-${day1DateStr}T20:00:00.000+08:00`),
    ],
    data: day1,
  },
  {
    time: [
      new Date(`2023-${day2DateStr}T11:30:00.000+08:00`),
      new Date(`2023-${day2DateStr}T19:00:00.000+08:00`),
      // new Date(`2022-${day2DateStr}T13:00:00.000+08:00`),
      // new Date(`2022-${day2DateStr}T18:40:00.000+08:00`),
    ],
    data: day2,
  },
]

exports.day1 = day1
exports.day2 = day2
exports.days = daysData.map((d) => d.data)
exports.daysTime = daysData.map((d) => d.time)
exports.TalkType = TalkType
